// eslint-disable-next-line no-unused-vars
/**
 * @class Core
 * @classdesc TToggle 에서 사용하는 functional class
 * @param params
 * @param {VueComponent} params.toggle
 */
export default ({ toggle }) => {
  return {
    btns    : [], // 버튼 배열
    contents: [], // 컨텐츠 배열
    init() {
      /* this.addEvent(); */
    },
    /**
     * 서브 컴포넌트들의 index 매칭을 위한 등록 함수
     * @memberof Core#
     * @param {VueComponent} item
     * @returns mount()에 의해 push()되는 순서대로 index 반환
     */
    register(item) {
      let r;
      switch (item.$vnode.componentOptions.tag) {
        case 't-toggle-button' :
          this.btns.push(item);
          r = this.btns;
          break;

        case 't-toggle-content' :
          this.contents.push(item);
          r = this.contents;
          break;

        default :
      }

      return { index: item.idx ? item.idx : r.length - 1 };
    },
    changeHash() {
      if (
        window.location.hash === '#none' ||
        window.location.hash === '' && window.location.href.substr(-1) === '#'
      ) {
        return;
      }

      toggle.change({
        index: this.getHashIndex() || 0,
        hash : window.location.hash
      });
    },
    /* addEvent() { // watch 로 $route 변경
      window.addEventListener(
        'hashchange',
        e => {
          console.log(e);
          this.changeHash();
        },
        false
      );
    }, */
    getHashIndex() {
      return this.btns
        .filter((item) => {
          return `${item.hash}` === window.location.hash;
        })
        .map((item) => {
          return item.index;
        })
        .pop();
    }
  };
};
